import React from "react";
import { FaWhatsapp } from "react-icons/fa";

import ChannelConnectCard from "../ChannelConnect/ChannelConnectCard";

/**
 * WhatsApp Cloud API. Unlike Messenger and Instagram the unit is a phone number
 * on a WhatsApp Business Account, not a Page — but the login is the same
 * Facebook one, and the token it returns is what lists and messages those
 * numbers (see WhatsAppAdminController).
 */
const whatsapp = {
  name: "WhatsApp",
  // Sent with the token so the server knows which channel was connected.
  key: "whatsapp",
  title: "Connect WhatsApp",
  subtitle: "Answer WhatsApp chats from your store, day and night.",
  logo: FaWhatsapp,
  // WhatsApp's brand green, dark to light.
  gradient: "linear(135deg, #075E54 0%, #128C7E 45%, #25D366 100%)",
  markColor: "#25D366",
  accentColor: "#128C7E",
  storePath: "/admin/bots/whatsapp",
  storageKeys: { user: "waUser", connected: "waAccountConnected" },
  scope: [
    "public_profile",
    "business_management",
    "whatsapp_business_management",
    "whatsapp_business_messaging",
  ].join(","),
  /** Reading the numbers needs the first; replying needs the second. */
  requiredScopes: ["whatsapp_business_management", "whatsapp_business_messaging"],
  capabilities: [
    "Reply to every WhatsApp chat on your business number",
    "Answer buyers automatically with your AI assistant",
    "Let buyers browse and order without leaving the chat",
  ],
  note:
    "You need a WhatsApp Business Account with a registered phone number. A number already used by the WhatsApp or WhatsApp Business app has to be migrated before it can be connected here.",
};

const ConnectToWhatsApp = () => <ChannelConnectCard channel={whatsapp} />;

export default ConnectToWhatsApp;
